import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { AccessibilityProvider } from './contexts/AccessibilityContext';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { IssuesPage } from './pages/IssuesPage';
import { AboutPage } from './pages/AboutPage';
import { SubmitPage } from './pages/SubmitPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <LanguageProvider data-id="element-0">
      <AccessibilityProvider data-id="element-1">
        <BrowserRouter data-id="element-2">
          <div className="min-h-screen flex flex-col bg-[#FAF6F0] app-container" data-id="element-3">
            <Navbar data-id="element-4" />
            <main className="flex-1 bg-[#FAF6F0] main-content" data-id="element-5">
              <Routes data-id="element-6">
                <Route path="/" element={<IssuesPage data-id="element-8" />} data-id="element-7" />
                <Route path="/about" element={<AboutPage data-id="element-10" />} data-id="element-9" />
                <Route path="/submit" element={<SubmitPage data-id="element-12" />} data-id="element-11" />
                <Route path="/contact" element={<ContactPage data-id="element-14" />} data-id="element-13" />
              </Routes>
            </main>
            <Footer data-id="element-15" />
          </div>
        </BrowserRouter>
      </AccessibilityProvider>
    </LanguageProvider>;
}